export default __webpack_public_path__ + "static/static-banner-2-8627cdb7c9ff4f2c699f4fc774f36295.jpg";